<template>
  <div class="container-fluid g-1 "> 
        <div class="row g-0 mt-4  messages-response">
                <div class="col-3 mt-3">
                        <div class="search-box search-box-bg">
                            <!-- <i class='bx bx-search-alt-2'></i>  -->
                                <input type="search" placeholder="ძიება..." class="search-input">

                        </div>

                        
                      <div class="recipient-box">
                        <div class="recipient">
                                <div class="row">
                                    <div class="col-2">
                                        <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
                                    
                                    </div>
                                    <div class="d-none d-md-none d-lg-block col-10 pt-3">
                                             <p class="ms-4">დავით ბიტმალკიშევ</p> 

                                    </div>

                                </div>

                        </div>
                        <div class="recipient">
                            <div class="row">
                                <div class="col-2">
                                    <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
                                
                                </div>
                                <div class=" d-none d-md-none d-lg-block col-10 pt-3">
                                           <p  class="ms-4">დავით ბიტმალკიშევ</p> 

                                </div>

                            </div>

                    </div>
                    <div class="recipient">
                        <div class="row">
                            <div class="col-2">
                                <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
                            
                            </div>
                            <div class="d-none d-md-none d-lg-block col-10 pt-3">
                                       <p  class="ms-4">დავით ბიტმალკიშევ</p> 

                            </div>

                        </div>

                </div>
                <div class="recipient">
                    <div class="row">
                        <div class="col-2">
                               <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
                        
                        </div>
                        <div class="d-none d-md-none d-lg-block col-10 pt-3">
                                   <p  class="ms-4">დავით ბიტმალკიშევ</p> 

                        </div>

                    </div>

            </div>
            <div class="recipient">
                <div class="row">
                    <div class="col-2">
                        <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
                    
                    </div>
                    <div class="d-none d-md-none d-lg-block col-10 pt-3">
                               <p  class="ms-4">დავით ბიტმალკიშევ</p> 

                    </div>

                </div>

        </div>
        <div class="recipient">
            <div class="row">
                <div class="col-2">
                      <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
                
                </div>
                <div class="d-none d-md-none d-lg-block col-10 pt-3">
                           <p  class="ms-4">დავით ბიტმალკიშევ</p> 

                </div>

            </div>

    </div>
    <div class="recipient">
        <div class="row">
            <div class="col-2">
                 <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
            
            </div>
            <div class="d-none d-md-none d-lg-block col-10 pt-3">
                       <p  class="ms-4">დავით ბიტმალკიშევ</p> 

            </div>

        </div>

</div>

<div class="recipient">
    <div class="row">
        <div class="col-2">
               <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
        
        </div>
        <div class=" d-none d-md-none d-lg-block col-10 pt-3">
                   <p  class="ms-4">დავით ბიტმალკიშევ</p> 

        </div>

    </div>

</div>
<div class="recipient">
    <div class="row">
        <div class="col-2">
             <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
        
        </div>
        <div class="d-none d-md-none d-lg-block col-10 pt-3">
                   <p  class="ms-4">დავით ბიტმალკიშევ</p> 

        </div>

    </div>

</div>
<div class="recipient">
    <div class="row">
        <div class="col-2">
             <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
        
        </div>
        <div class="d-none d-md-none d-lg-block col-10 pt-3">
                   <p class="ms-4">დავით ბიტმალკიშევ</p> 

        </div>

    </div>

</div>
<div class="recipient">
    <div class="row">
        <div class="col-2">
             <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
        
        </div>
        <div class="d-none d-md-none d-lg-block col-10 pt-3">
                   <p class="ms-4">დავით ბიტმალკიშევ</p> 

        </div>

    </div>

</div>
<div class="recipient">
    <div class="row">
        <div class="col-2">
               <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
        
        </div>
        <div class="d-none d-md-none d-lg-block col-10 pt-3">
                   <p class="ms-4">დავით ბიტმალკიშევ</p> 
                

        </div>

    </div>

</div>
<div class="recipient">
    <div class="row">
        <div class="col-2">
             <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
        </div>
        <div class="d-none d-md-none d-lg-block col-10 pt-3">
                   <p  class="ms-4">დავით ბიტმალკიშევ</p> 

        </div>

    </div>

</div>
                        
                      </div>  

                </div>


                <div class="col-9 mt-3">
                    <div class="active-recipient">
                        <div class="row ">
                            <div class="col-1">
                                  <img src="../assets/images/download.jpg" class="rounded-circle" alt="">
                            
                            </div>
                            <div class="d-none d-md-none d-lg-block col-11 pt-3 ">
                                       <p class="ms-4">დავით ბიტმალკიშევ</p> 
                    
                            </div>
                    
                        </div>

                    </div>
                        <div class="chat-box ">
                                <div class="chat chat-left">
                                   გამარჯობა 
                                </div>
                                <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                 <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                 <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                 <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white ">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                <div class="chat chat-left">
                                    გამარჯობა 
                                 </div>
                                <div class="chat chat-right text-white">
                                    როგორ ხარ 
                                </div>
                                
                                 
                        </div>
                        <div class="message-box">
                            <textarea placeholder="შეტყობინება"></textarea>
                            <i class='bx bx-paperclip fs-2'></i>
                            <i class='bx bx-send fs-2' ></i>
                        </div>
                     
                </div>
        </div>

   </div>  
    
</template>